document.addEventListener('DOMContentLoaded', () => {
  initSwatchTooltips();
});

// Initialize tooltips for color swatches
function initSwatchTooltips() {
  // Select all swatch view items
  const swatchItems = document.querySelectorAll('.swatch-view-item');

  // For each swatch item, add a tooltip
  swatchItems.forEach(item => {
    addTooltipToSwatchItem(item);
  });
  
  // Set up a mutation observer to handle dynamically added swatches
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length) {
        mutation.addedNodes.forEach(node => {
          // Check if the added node contains swatch items
          if (node.nodeType === 1) { // Element node
            const newSwatchItems = node.querySelectorAll ? 
              node.querySelectorAll('.swatch-view-item') : [];
            
            // If it's a swatch item itself
            if (node.classList && node.classList.contains('swatch-view-item')) {
              addTooltipToSwatchItem(node);
            }
            
            // Or if it contains swatch items
            if (newSwatchItems.length) {
              newSwatchItems.forEach(addTooltipToSwatchItem);
            }
          }
        });
      }
    });
  });
  
  // Function to add tooltip to a single swatch item
  function addTooltipToSwatchItem(item) {
    // Check if tooltip already exists
    if (item.querySelector('.swatch-tooltip')) return;
    
    const colorName = item.getAttribute('aria-label');
    if (colorName) {
      // Find the color value (background color or image)
      const swatchElement = item.querySelector('.swatch-custom-image') || item.querySelector('.swatch-selector');
      let backgroundImage = '';
      let backgroundColor = '';
      let hasStarSetImage = false;
      
      if (swatchElement) {
        // Try to get background image from the star-set-image
        const imgElement = swatchElement.querySelector('.star-set-image');
        if (imgElement) {
          hasStarSetImage = true;
          backgroundImage = getComputedStyle(imgElement).backgroundImage;
        }
        
        // Only proceed if there's a star-set-image
        if (!hasStarSetImage) {
          return;
        }
        
        // Try to get data-value (color value) from swatch-selector
        if (swatchElement.hasAttribute('data-value')) {
          backgroundColor = swatchElement.getAttribute('data-value');
          
          // Check if it's a valid color name or hex
          if (!backgroundColor.startsWith('#') && !isValidColorName(backgroundColor)) {
            // If not a valid color format, try to convert from name
            const colorMap = {
              'White': '#FFFFFF',
              'Black': '#000000',
              'Red': '#FF0000',
              'Green': '#008000',
              'Blue': '#0000FF',
              'Yellow': '#FFFF00',
              'Purple': '#800080',
              'Orange': '#FFA500',
              'Pink': '#FFC0CB',
              'Brown': '#A52A2A',
              'Gray': '#808080',
              'Grey': '#808080'
            };
            
            backgroundColor = colorMap[backgroundColor] || colorMap[colorName] || backgroundColor;
          }
        }
      } else {
        // No swatch element found, exit
        return;
      }
      
      // Create tooltip element
      const tooltip = document.createElement('div');
      tooltip.classList.add('swatch-tooltip');
      
      // Add color preview at the top
      const colorPreview = document.createElement('div');
      colorPreview.classList.add('swatch-tooltip-color');
      colorPreview.style.width = '100px';
      colorPreview.style.height = '100px';
      colorPreview.style.marginBottom = '5px';
      colorPreview.style.borderRadius = '2px';
      
      // Apply the background image or color to the preview
      if (backgroundImage && backgroundImage !== 'none') {
        colorPreview.style.backgroundImage = backgroundImage;
        colorPreview.style.backgroundSize = 'cover';
        colorPreview.style.backgroundPosition = 'center';
      } else if (backgroundColor) {
        colorPreview.style.backgroundColor = backgroundColor;
      } else {
        // Last resort - try to match by color name
        colorPreview.style.backgroundColor = colorName;
      }
      
      // Add color name text
      const colorText = document.createElement('div');
      colorText.textContent = colorName;
      
      // Add elements to tooltip
      tooltip.appendChild(colorPreview);
      tooltip.appendChild(colorText);
      
      item.appendChild(tooltip);
      
      // Track which tooltip is currently active (for mobile)
      let activeTooltip = null;
      
      // Function to position tooltip correctly
      const positionTooltip = () => {
        // Get dimensions after tooltip is visible
        const tooltipRect = tooltip.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        
        // Calculate window edges
        const windowWidth = window.innerWidth;
        
        // Check if tooltip extends beyond left edge
        if (tooltipRect.left < 0) {
          const leftOffset = Math.abs(tooltipRect.left) + 10;
          tooltip.style.left = `calc(50% + ${leftOffset}px)`;
          tooltip.style.setProperty('--arrow-left', `calc(50% - ${leftOffset}px)`);
        } 
        // Check if tooltip extends beyond right edge
        else if (tooltipRect.right > windowWidth) {
          const rightOffset = (tooltipRect.right - windowWidth) + 10;
          tooltip.style.left = `calc(50% - ${rightOffset}px)`;
          tooltip.style.setProperty('--arrow-left', `calc(50% + ${rightOffset}px)`);
        }
      };
      
      // Show tooltip
      const showTooltip = () => {
        // Hide any previously active tooltip
        if (activeTooltip && activeTooltip !== tooltip) {
          activeTooltip.style.opacity = '0';
        }
        
        // Show this tooltip first
        tooltip.style.opacity = '1';
        activeTooltip = tooltip;
        
        // Need to wait for the tooltip to be visible before positioning it correctly
        // This ensures getBoundingClientRect() returns accurate dimensions
        requestAnimationFrame(() => {
          // Reset transform to default centered position first
          tooltip.style.left = '50%';
          tooltip.style.right = 'auto';
          tooltip.style.transform = 'translate(-50%, 0)';
          tooltip.style.setProperty('--arrow-left', '50%');
          
          // Now position the tooltip after it's visible
          positionTooltip();
        });
      };
      
      // Hide tooltip
      const hideTooltip = () => {
        tooltip.style.opacity = '0';
        if (activeTooltip === tooltip) {
          activeTooltip = null;
        }
      };
      
      // Desktop events
      item.addEventListener('mouseenter', showTooltip);
      item.addEventListener('mouseleave', hideTooltip);
      
    }
  }
  
  // Helper function to check if a string is a valid CSS color name
  function isValidColorName(strColor) {
    const s = new Option().style;
    s.color = strColor;
    return s.color !== '';
  }
  
  // Observe the entire document body for changes
  observer.observe(document.body, { 
    childList: true,
    subtree: true 
  });
} 